import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=38892b49&scoped=true&"
import script from "./Package.vue?vue&type=script&lang=js&"
export * from "./Package.vue?vue&type=script&lang=js&"
import style0 from "./Package.vue?vue&type=style&index=0&id=38892b49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38892b49",
  null
  
)

component.options.__file = "Package.vue"
export default component.exports